﻿/* globals ListadosDesktopIndexDTO, LiveNotificationDTO, ModuloLiderDTO, FavoriteRateCommentDTO, ModalAlertaFiltroDTO, FavoritosDTO, ListGalleryDTO, OutlookHotmailDTO, hj, __tcfapi */
import jquery from 'jquery';
import slick from 'slick';
import Publicidad from './modules/publicidad';
import FiltrosDesktop from './modules/filter-desktop';
import LiveNotifications from '../Global/live-notifications';
import tooltipster from 'tooltipster';
import SeenHandler from '../Global/seen-handler';
import ModalAvisame from './modules/modal-avisame';
import ModalLegal from './modules/modal-legal';
import HotmailOutlookModal from '../Global/hotmail-outlook-modal';
import ModalAlertaFiltro from './modules/modal-alerta-filtro';
import ModuloLider from '../Common/modulo-lider';
import HabEvents from '../Global/habitaclia-events';
import FavoritosRepository from '../Common/Favoritos/repository/favoritos-repository';
import FavoritosService from '../Common/Favoritos/services/favoritos-service';
import FavoritosRateCommentDesktopUI from '../Common/Favoritos/ui/favoritos-rate-comment-desktop-ui';
import cookieService from '../Global/cookie-service';
var ListGallery = require('../Global/list-gallery');
import '../Global/show-message';

//trackings
import '../Common/Trackings/gtm-ecommerce';
import '../Common/Trackings/comscore';
import '../Common/Trackings/google-gtm-events';
import '../Common/Trackings/segment';
import './modules/alerts-ui';

class ListadosDesktopIndex{
    
    constructor(listadosDesktopIndexDTO, LiveNotificationDTO, modalAlertaFiltroDTO, ListGalleryDTO, OutlookHotmailDTO) {
      
        this.listadosDesktopIndexDTO = listadosDesktopIndexDTO;
        this.__liveNotificationDTO = LiveNotificationDTO;
        this.__liveNotifications;
        this.__$mainList = jquery('#js-list');
        this.__$selectOrder = jquery('#order-by');
        this.__$order = jquery('#js-order');
        this.__$changeViewList =jquery('#js-changeview-list');
        this.__$changeViewPhoto =jquery('#js-changeview-photo');
        this.__$changeViewMap =jquery('#js-changeview-map');
        this.__header = document.getElementById('js-header-container');
        this.__headerSecond = document.getElementById('js-head-second-content');
        this.__$linksFavoritos = jquery('.favlink');
        this.__headerTotalOffset = 106;
        this.__lastScrolled = 0;
        this.__formFiltros = document.forms.FiltroInmuebles;
        this.__filterContainer = document.getElementById('js-filters');
        this.__saveSearchContainer = document.getElementById('js-save-search');
        this.__$itemsWithLink = jquery('.js-item-with-link');
        this.__$showSaveSearch = jquery('#js-show-search-responsive');
        this.__$showfilter = jquery('#js-show-filter-responsive');
        this.__$searchbox = jquery('#js-save-search');
        this.__$filterbox = jquery('#js-filters');
        this.__$closeSearchbox = jquery('#js-close-save-search');
        this.__$closeFilterbox = jquery('#js-close-filter');
        this.__$paginationAlert = jquery('#js-pagination-create-alert');
        this.__$leyOmnibusButton = jquery('.ley-omnibus-info-btn');
        this.__$leyOmnibusCloseButton = jquery('.ley-omnibus-close-btn');
        this.__$leyOmnibusContent = jquery('.ley-omnibus-info-content');
        this.__krCookieName = 'kr_asked';
        this.__krCookieTime = 5256000;
        this.__filterHeight = this.__filterContainer ? this.__filterContainer.getBoundingClientRect().height + this.__headerTotalOffset : this.__headerTotalOffset;
        this.seenHandler = new SeenHandler();
        this.registerEvents();
        this.listGallery = new ListGallery(ListGalleryDTO);

        __tcfapi && __tcfapi('getTCData',2, data => {
            if (data.purpose.consents[5] && data.purpose.consents[6] && data.purpose.consents[10]){
                this.checkSeenDetails();
            }
        });

        this.publicidad = new Publicidad(this.listadosDesktopIndexDTO.publicidad);
        this.filtrosDesktop = new FiltrosDesktop(this.listadosDesktopIndexDTO.filterDesktopDTO);
        this.moduloLider = typeof (ModuloLiderDTO) !== "undefined" && new ModuloLider(ModuloLiderDTO);
        const favoritosRepository = new FavoritosRepository(FavoritosDTO);
        const favoritosService = new FavoritosService(favoritosRepository, FavoritosDTO);
        this.favoritosRateCommentDesktopUI = new FavoritosRateCommentDesktopUI(FavoriteRateCommentDTO, favoritosService);
        this.modalAlertaFiltro = new ModalAlertaFiltro(modalAlertaFiltroDTO);
        this.hotmailOutlookModal = new HotmailOutlookModal(OutlookHotmailDTO);
    }

    registerEvents() {
        if(this.__header){
            window.addEventListener('scroll', ()=>{
                this.stickyHeader();

            });
        }

        this.__$showSaveSearch.on('click', ()=> {
            this.__$searchbox.addClass('show');
        });
        this.__$showfilter.on('click', ()=> {
            this.__$filterbox.addClass('show');
        });
        this.__$closeSearchbox.on('click', ()=> {
            this.__$searchbox.removeClass('show');
        });
        this.__$closeFilterbox.on('click', ()=> {
            this.__$filterbox.removeClass('show');
        });

        this.__$leyOmnibusButton.on('click', () => {
            this.__$leyOmnibusContent.addClass('show');
        });
        
        this.__$leyOmnibusCloseButton.on('click', () => {
            this.__$leyOmnibusContent.removeClass('show');
        });

        jquery('.jq-tooltip').tooltipster({ contentCloning: true });

        jquery('#list-online-appraisal-button').click(() => {
            this.trackEvent();
        });

        ModalLegal.RegisterEvents();

        this.__$selectOrder.change((event) => {
            const $ordenar = jquery('option:selected', event.currentTarget);
            const nombreOrden = $ordenar.attr("data-nombre_orden");
            jquery.publish(HabEvents.EventsEnum.CambioOrdenacionLista, [this.__tipoLista, nombreOrden]);
            this.__$order.val($ordenar.val());
            this.__formFiltros.submit();
        });

        this.__$changeViewList.click(()=>{
            this.__$changeViewList.addClass('active');
            this.__$changeViewPhoto.removeClass('active');
            this.__$mainList.removeClass('list-photo');
            this.__tipoLista = 'vlist';
            jquery.publish(HabEvents.EventsEnum.CambioVistaLista, [this.__tipoLista, 'listado']);
            cookieService.setCookie('listset', 'list', Infinity);
        });

        this.__$changeViewPhoto.click(()=>{
            this.__$changeViewPhoto.addClass('active');
            this.__$changeViewList.removeClass('active');
            this.__$mainList.addClass('list-photo');
            this.__tipoLista = 'vgrid';
            jquery.publish(HabEvents.EventsEnum.CambioVistaLista, [this.__tipoLista, 'fotosgrandes']);
            cookieService.setCookie('listset', 'photo', Infinity);
        });

        this.__$changeViewMap.click(() => {
            jquery.publish(HabEvents.EventsEnum.CambioVistaLista, ['vmapa', 'mapa']);
        });

        this.__liveNotifications = new LiveNotifications(this.__liveNotificationDTO);

        if (this.listadosDesktopIndexDTO.idUsuario === 0) {
            setTimeout(() => {
                this.__liveNotifications.SetLiveFromTemplate('info-alerta', '<img src="' + this.__liveNotificationDTO.helpImage + '"><div class="live-info-container"><span class="live-title">' + this.__liveNotificationDTO.helpText + '</span><button type="button">' + this.__liveNotificationDTO.helpButton + '</button></div>', 'live-item pointer-events-all bg-black-alpha', this.__liveNotificationDTO.helpLink);
            }, 60000);
        }

        jquery('.jq-tooltip').tooltipster({ contentCloning: true });
    } 

    trackEvent()  {
        jquery.publish(HabEvents.EventsEnum.PropertyValuationLandingButtonClicked, 'list');
    }

    stickyHeader() {
        if(window.pageYOffset < this.__headerTotalOffset){
            this.__header.style.transform = 'translate(0,-'+ window.pageYOffset +'px)';
        }
        if (window.pageYOffset >= this.__headerTotalOffset) {
            this.__header.classList.add("scrolled");
            if(this.__lastScrolled > window.pageYOffset){
                this.__header.classList.add("header-list-up-down");
            }else{
                this.__header.classList.remove("header-list-up-down");
            }
        } else {
            this.__header.classList.remove("scrolled");
            this.__header.classList.remove("header-list-up");
        }
        if (window.pageYOffset >= this.__headerTotalOffset + 300) {
            this.__header.classList.add("header-list-up");
        }else{
            this.__header.classList.remove("header-list-up-down");
        }
        this.__lastScrolled = window.pageYOffset;
        if(window.pageYOffset >= this.__filterHeight){
	        this.__saveSearchContainer && this.__saveSearchContainer.classList.add('save-search-down');
        }else{
	        this.__saveSearchContainer && this.__saveSearchContainer.classList.remove('save-search-down');
            this.__header.classList.remove("header-list-up-down");
        }
    }
  
    checkSeenDetails(){
        const listDetails = document.querySelectorAll('.js-list-item');
        listDetails.forEach(detail => {
            if(typeof(detail)!=="number"){
                const dataId = detail.getAttribute('data-id');
                if (this.seenHandler.estaVisitado(dataId)) {
                    const tagSeenTemplate = document.getElementById('{{tag-seen-template}}').cloneNode(true);
                    tagSeenTemplate.id = 'seen-'+dataId;
                    const mediaContainer = document.querySelector('[id="id'+dataId+'"] .list-item-media');
                    mediaContainer.appendChild(tagSeenTemplate);
                    detail.classList.add('list-item-seen');
                }
            }
        });
    }
}

/* jshint unused: false */
const listadosDesktopInstance = new ListadosDesktopIndex(ListadosDesktopIndexDTO, LiveNotificationDTO, ModalAlertaFiltroDTO, ListGalleryDTO, OutlookHotmailDTO);